var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-content"},[_c('img',{staticClass:"img-content",attrs:{"src":require("@/assets/images/website/home/nodata.png")}}),_c('p',{staticClass:"text-content"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }